import { Component, EventEmitter, Input, Output, TemplateRef } from '@angular/core';
import { IssueTrackerIncidenceDTO } from '../../../models/issue-tracker-incidence-dto';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-incidence-info',
  templateUrl: './incidence-info.component.html',
  styleUrls: ['./incidence-info.component.scss'],
  standalone: true,
  imports: [CommonModule]
})
export class IncidenceInfoComponent {

  @Input() incidence: IssueTrackerIncidenceDTO;
  @Input() isAdmin: boolean = false;
  @Input() changeStatusControl?: TemplateRef<unknown>;
  @Input() savingPhoneCallNeeded: boolean = false;
  @Input() savingNoAutoClose: boolean = false;
  @Output() toggleOtherIncidencesEvent: EventEmitter<void> = new EventEmitter<void>();
  @Output() phoneCallNeededChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() noAutoCloseChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  get contactDataArray() {
    const contactData = this.incidence?.ContactData;
    if (contactData && contactData !== '') {
      try {
        return JSON.parse(contactData);
      } catch {
        return [];
      }
    }
    return [];
  }

  toggleOtherIncidences() {
    this.toggleOtherIncidencesEvent.emit();
    console.log('toggleOtherIncidencesEvent emitted');
  }

  onPhoneCallNeededChange(event: Event) {
    this.phoneCallNeededChange.emit((event.target as HTMLInputElement).checked);
  }

  onNoAutoCloseChange(event: Event) {
    this.noAutoCloseChange.emit((event.target as HTMLInputElement).checked);
  }
}
